import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { getUserDisplayName } from '../utils/userUtils';
import './TeachersList.css';

const TeachersList = () => {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || user.user_type !== 'student') {
      navigate('/dashboard');
      return;
    }
    fetchTeachers();
  }, [user, navigate]);

  const fetchTeachers = async () => {
    try {
      const response = await api.get('/auth/teachers/');
      setTeachers(response.data);
    } catch (error) {
      console.error('Ошибка загрузки преподавателей:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleTeacherClick = (teacherId) => {
    navigate(`/teachers/${teacherId}`);
  };

  if (loading) {
    return (
      <div className="teachers-list-page">
        <Header />
        <main className="teachers-list-main">
          <div className="teachers-list-container">
            <div className="loading-message">Загрузка...</div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="teachers-list-page">
      <Header />
      <main className="teachers-list-main">
        <div className="teachers-list-container">
          <h1 className="page-title">Выберите преподавателя</h1>
          <div className="teachers-grid">
            {teachers.map((teacher) => (
              <div key={teacher.id} className="teacher-card">
                <div className="teacher-card-content">
                  <div className="teacher-avatar">
                    {teacher.avatar_url ? (
                      <img src={teacher.avatar_url} alt={teacher.username} />
                    ) : (
                      <div className="teacher-avatar-placeholder">
                        {teacher.first_name?.[0] || teacher.username[0].toUpperCase()}
                      </div>
                    )}
                  </div>
                  <div className="teacher-info">
                    <h3 className="teacher-name">
                      {getUserDisplayName(teacher)}
                    </h3>
                    <p className="teacher-username">@{teacher.username}</p>
                    {teacher.bio && (
                      <p className="teacher-bio">
                        {teacher.bio.length > 150 
                          ? `${teacher.bio.substring(0, 150)}...` 
                          : teacher.bio
                        }
                      </p>
                    )}
                    <button
                      className="btn-details"
                      onClick={() => handleTeacherClick(teacher.id)}
                    >
                      Подробнее
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {teachers.length === 0 && (
            <div className="no-teachers">Нет доступных преподавателей</div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TeachersList;
